var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38507 3.05644H3.97994V2.13336H4.63635V3.05644H11.3646V2.13336H12.021V3.05644H12.6158C13.303 3.05644 13.8671 3.62054 13.8671 4.30772V12.6154C13.8671 13.3026 13.303 13.8667 12.6158 13.8667H3.38507C2.69789 13.8667 2.13379 13.3026 2.13379 12.6154V4.30772C2.13379 3.62054 2.69789 3.05644 3.38507 3.05644ZM3.97994 4.63593V3.71285H3.38507C3.05182 3.71285 2.7902 3.97447 2.7902 4.30772V5.82567H13.2107V4.30772C13.2107 3.97447 12.9491 3.71285 12.6158 3.71285H12.021V4.63593H11.3646V3.71285H4.63635V4.63593H3.97994ZM13.2107 6.48208H2.7902V12.6154C2.7902 12.9487 3.05182 13.2103 3.38507 13.2103H12.6158C12.9491 13.2103 13.2107 12.9487 13.2107 12.6154V6.48208ZM5.8261 9.51798H7.67225V7.67182H8.32866V9.51798H10.1748V10.1744H8.32866V12.0205H7.67225V10.1744H5.8261V9.51798Z",
    fill: "#326164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.6c2d2b61202913da44bef8e1b81e1ed5.svg";
export { ForwardRef as ReactComponent };